import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../app/store";
import { archiveProject } from "../../../projectSlice";
import ConfirmDialog from "../../../../UI/ConfirmDialog";
import { useState } from "react";
import { projectsApi } from "../../../projectApi";

interface ArchiveProps {
    projectId: number;
}

const ProjectViewArchive = (props: ArchiveProps) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { projectId } = props;

    const projectStatus = useSelector((state: RootState) => state.selectedProject.project.status);

    const [archiveDialogOpen, setArchiveDialogOpen] = useState<boolean>(false);
    
    return (
      <>
      <div style={{ marginRight: "50%", marginTop: "10px" }}>
        <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
          {t("projectview_page.settings_page.archiveProjectHeader")}
        </div>
        <p>{t("projectview_page.settings_page.archiveProject.info")}</p>
        <Button 
            variant="contained" 
            size="small"
            disabled={projectStatus === 4}
            sx={{ marginTop: "15px" }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setArchiveDialogOpen(true);
            }}
        >
          {t("projectview_page.settings_page.archiveProjectHeader")}
        </Button>
      </div>
      <ConfirmDialog 
        key={"project-archive-confirm-dialog"}
        open={archiveDialogOpen}
        value={projectId}
        setOpen={setArchiveDialogOpen}
        onConfirm={() => {
          dispatch(archiveProject(projectId));
          dispatch(projectsApi.util.invalidateTags([{ type: "Projects", id: "USER_PROJECTS_LIST" }]));
        }}
        content={t("projectview_page.settings_page.archiveProject.confirm_dialog")}
      />
      </>
    );
};

export default ProjectViewArchive;